module.exports = __webpack_public_path__ + "img/img3.500c4d61.jpg";